import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          .pac-container {
            z-index: 1500 !important;
            min-width: 400px !important;
          }
          .MuiFormControl-root {
            padding-bottom: 0 !important;
          }
        `
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'underline !important',
          color: '#000',
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline'
          }
        }
      },
      defaultProps: {
        underline: 'always'
      }
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    body2: {
      fontSize: '15px'
    },
    body1: {
      fontSize: '15px'
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#c32051' // red
    },
    info: {
      main: '#4e4e4e' // gray
    },
    secondary: {
      main: '#335d87' // blue
    }
  }
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#c32051' },
    secondary: { main: '#252525ff' },
    background: {
      default: '#121212',
      paper: '#1e1e1e'
    },
    text: {
      primary: '#e0e0e0',
      secondary: '#a0a0a0'
    },
    divider: 'rgba(0, 0, 0, 0.12)'
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        body: {
          backgroundColor: '#121212',
          color: '#e0e0e0',
          '& .MuiDataGrid-root': {
            border: 'none',
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid rgba(255,255,255,0.12)'
            },
            '& .MuiDataGrid-columnHeaders': {
              borderBottom: '1px solid rgba(255,255,255,0.12)'
            }
          }
        },
        '.react-tel-input input.form-control': {
          backgroundColor: '#1e1e1e',
          color: '#e0e0e0',
          border: '1px solid #8f8f8fff',
          borderRadius: '8px',
          padding: '10px 12px',
          width: '100%'
        },

        '.react-tel-input input.form-control:focus': {
          borderColor: '#b71c5c',
          boxShadow: '0 0 0 1px #b71c5c'
        },
        '.react-tel-input input.form-control:hover': {
          boxShadow: '0 0 0 1px #bababaff'
        },

        '.react-tel-input .flag-dropdown': {
          backgroundColor: '#f0e6e6ff',
          border: '1px solid #444',
          borderRight: 'none'
        },

        '.react-tel-input .selected-flag': {
          backgroundColor: '#1e1e1e !important'
        },

        '.react-tel-input .country-list': {
          backgroundColor: '#1e1e1e',
          color: '#e0e0e0',
          border: '1px solid #444'
        },

        '.react-tel-input .country-list .country:hover': {
          backgroundColor: '#2a2a2a'
        },

        '.phone-input.red-border input.form-control': {
          borderColor: '#d7d4d4ff !important'
        },
        '.active-inactive-admin-ws-div': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        '.active-inactive-admin-ws-btn': {
          width: 'max-content',
          marginBottom: '10px',
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.background.paper : '#f4f4f4',
          padding: '15px',
          borderRadius: '5px'
        },
        '.active-inactive-admin-ws-btn div:first-child': {
          marginRight: '10px'
        },
        /* Buttons */
        '.active-inactive-admin-ws': {
          padding: '6px 10px',
          borderRadius: '5px',
          display: 'inline-block',
          cursor: 'pointer',
          transition: 'all 0.3s',
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.text.secondary
              : theme.palette.text.primary
        },
        '.active-inactive-admin-ws div': {
          display: 'inline'
        },
        '.active-inactive-admin-ws.active': {
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.background.default : '#fafafa',
          color: theme.palette.mode === 'dark' ? theme.palette.primary.main : '#335d87'
        },
        '.active-inactive-admin-ws span': {
          fontSize: '12px',
          color: '#fff',
          background: theme.palette.primary.main,
          padding: '4px 5px',
          borderRadius: '8px'
        },
        /* Status buttons */
        '.status-btn': {
          backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#d6dfe7',
          marginRight: '10px',
          border: 'none',
          borderRadius: '10px',
          padding: '8px 12px',
          width: 'max-content',
          display: 'inline-block',
          cursor: 'pointer'
        },
        '.status-btn.active': {
          backgroundColor: theme.palette.mode === 'dark' ? '#666' : '#bac1c8'
        }
      })
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          color: '#e0e0e0'
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: 'inherit',
          color: 'inherit'
        }
      }
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1e1e1e',
          color: '#e0e0e0'
        }
      }
    },

    MuiList: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary
        })
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(255,255,255,0.1)'
          },
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.08)'
          }
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: ({ theme }) => ({
          color: theme.palette.text.primary,
          fontWeight: 500
        })
      }
    },
    MuiCollapse: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent'
        }
      }
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none'
        },
        outlined: {
          borderColor: 'rgba(255,255,255,0.3)',
          color: '#e0e0e0'
        },
        contained: {
          backgroundColor: '#b71c5c',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#9a174f'
          }
        }
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          color: '#e0e0ee',
          backgroundImage: 'none'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiOutlinedInput-root': {
            borderRadius: '50px',
            backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#fff',
            color: theme.palette.text.primary,
            '& fieldset': {
              borderColor: theme.palette.divider
            },
            '&:hover fieldset': {
              borderColor: theme.palette.text.secondary
            }
          }
        })
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px #000000ff inset',
            WebkitTextFillColor: '#ffffff',
            transition: 'background-color 5000s ease-in-out 0s'
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#e0e0e0'
        }
      }
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255,255,255,0.12)'
        }
      }
    },

    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          borderCollapse: 'collapse',
          overflow: 'hidden'
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            fontWeight: 600,
            fontSize: '0.875rem'
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: '#0f0f0fff',
          borderBottom: '1px solid rgba(255, 255, 255, 1)',
          color: '#ffffffff',
          fontSize: '0.875rem',
          padding: '12px 16px',
          '&.MuiTableCell-head': {
            backgroundColor: '#2a2a2a',
            color: '#fcfcfcff',
            fontWeight: 600
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: '#b40000ff'
        }
      }
    },

    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: '#e0e0e0',
          borderTop: '1px solid rgba(255,255,255,0.12)'
        },
        actions: {
          '& .MuiIconButton-root': {
            color: '#e0e0e0',
            '&:disabled': {
              color: 'rgba(255,255,255,0.3)'
            }
          }
        },
        selectIcon: {
          color: '#e0e0e0'
        }
      }
    },

    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#e0e0e0'
        }
      }
    }
  }
});
